import createIcon from '../../createIcon';

/**
 * @component @name BlindsClosed
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTguMTI1VjIuMTI1SDRWMTguMTI1SDJWMjAuMTI1SDEzLjI1QzEzLjI1IDIxLjA5NSAxNC4wMyAyMS44NzUgMTUgMjEuODc1QzE1Ljk3IDIxLjg3NSAxNi43NSAyMS4wOTUgMTYuNzUgMjAuMTI1SDIyVjE4LjEyNUgyMFpNMTggMTAuMTI1SDE2VjguMTI1SDE4VjEwLjEyNVpNMTQgMTAuMTI1SDZWOC4xMjVIMTRWMTAuMTI1Wk0xNCAxMi4xMjVWMTQuMTI1SDZWMTIuMTI1SDE0Wk0xNiAxMi4xMjVIMThWMTQuMTI1SDE2VjEyLjEyNVpNMTggNi4xMjVIMTZWNC4xMjVIMThWNi4xMjVaTTE0IDQuMTI1VjYuMTI1SDZWNC4xMjVIMTRaTTYgMTguMTI1VjE2LjEyNUgxNFYxOC4xMjVINlpNMTYgMTguMTI1VjE2LjEyNUgxOFYxOC4xMjVIMTZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BlindsClosed = createIcon('BlindsClosed', [
  [
    'path',
    {
      d: 'M20 18.125V2.125H4V18.125H2V20.125H13.25C13.25 21.095 14.03 21.875 15 21.875C15.97 21.875 16.75 21.095 16.75 20.125H22V18.125H20ZM18 10.125H16V8.125H18V10.125ZM14 10.125H6V8.125H14V10.125ZM14 12.125V14.125H6V12.125H14ZM16 12.125H18V14.125H16V12.125ZM18 6.125H16V4.125H18V6.125ZM14 4.125V6.125H6V4.125H14ZM6 18.125V16.125H14V18.125H6ZM16 18.125V16.125H18V18.125H16Z',
      key: '18xg8q',
    },
  ],
]);

export default BlindsClosed;
